/**
 * SuggestPass.jsx
 * Created by michaelbray on 2/23/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Row, Cell, Button } from './layout';

const propTypes = {
    history: PropTypes.object
};

export const annualPassPath = '/pass/order-details/pass/7005cd6e-8386-458e-b4b1-8b382bf70889';

export default class SuggestPass extends React.Component {
    constructor(props) {
        super(props);

        this.navigateTo = this.navigateTo.bind(this);
    }

    navigateTo() {
        window.location.assign(annualPassPath);
    }

    render() {
        return (
            <Row>
                <Cell className="pass-suggestion">
                    <div>
                        <div className="rec-aside-header">
                            <div>Get an Annual Pass</div>
                        </div>
                    </div>
                    <div className="pass-suggestion-body">
                        <Row>
                            <Cell className="align-center">
                                <p className="callout">
                                    Covers admittance to National Parks and over 2,000 federal recreation sites.
                                </p>
                            </Cell>
                        </Row>
                        <Row>
                            <Cell className="align-center">
                                <img src={`${process.env.CDN}/img/pass/annual_pass.jpg`} alt="Annual Pass" />
                            </Cell>
                        </Row>
                        <Row>
                            <Cell>
                                <Button
                                    mode="tertiary"
                                    size="large"
                                    onClick={this.navigateTo}
                                    aria-label="Purchase an Annual Park Pass" >
                                    Purchase Pass
                                </Button>
                            </Cell>
                        </Row>
                    </div>
                </Cell>
            </Row>
        );
    }
}

SuggestPass.propTypes = propTypes;
